var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d3c;}.cls-2{fill:#fff;}.cls-3{fill:#a440f2;}.cls-4{fill:#38d6b2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0V256H288V224.49h32V256h96V220.18h32V256H576V220.18h32V256H736V220.18H864v8.71h0V256H992V220.18h32v8.71h0V256h416V0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.99 191.99 191.98 191.99 191.98 160 96 160 96 64.02 191.98 64.02 191.98 32 31.99 32 31.99 191.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224,192h64V128h32v64h64V128H352V96h32V32H224ZM288,64h32V96H288Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "544.01 96 480.01 96 480.01 32 416.01 32 416.01 96 447.99 96 447.99 127.98 480.01 127.98 480.01 191.99 544.01 191.99 544.01 127.98 576 127.98 576 95.85 608.02 95.85 608.02 32 544.01 32 544.01 96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M640,192h64V128h96V32H640ZM704,64h32V96H704Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "832.01 64.02 896.01 64.02 896.01 191.99 960.01 191.99 960.01 64.02 1023.98 64.02 1023.98 32 832.01 32 832.01 64.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1056 191.99 1215.99 191.99 1215.99 160 1120 160 1120 127.98 1184 127.98 1184 96 1120 96 1120 64.02 1215.99 64.02 1215.99 32 1056 32 1056 191.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1407.99 96 1407.99 32 1344.03 32 1344.03 96 1312.01 96 1312.01 32 1248.01 32 1248.01 96 1280.03 96 1280.03 127.98 1248.01 127.98 1248.01 191.99 1312.01 191.99 1312.01 127.98 1344.03 127.98 1344.03 191.99 1407.99 191.99 1407.99 127.98 1376.01 127.98 1376.01 96 1407.99 96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.99,
    y: 220.5,
    width: 227.84,
    height: 7.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 349.24,
    y: 220.5,
    width: 34.75,
    height: 7.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480.05,
    y: 220.5,
    width: 63.79,
    height: 7.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 640,
    y: 220.5,
    width: 63.79,
    height: 7.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 896.1,
    y: 220.5,
    width: 63.79,
    height: 7.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1056,
    y: 220.5,
    width: 352,
    height: 7.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ef90d1b9e1e9a87aaff5b99c230d658.svg";
export { ForwardRef as ReactComponent };